import XLSX from 'xlsx'
import { getTimestampString } from '@/lib/display'

const getFileName = (fileName) => {
  return `${fileName}_${getTimestampString()}.xlsx`
}

function autoWidth (ws, data) {
  const colWidth = data.map(row => row.map(val => {
    if (val == null) {
      return { 'wch': 10 }
    } else if (val.toString().charCodeAt(0) > 255) {
      return { 'wch': val.toString().length * 2 }
    } else {
      return { 'wch': val.toString().length }
    }
  }))
  let result = colWidth[0]
  for (let i = 1; i < colWidth.length; i++) {
    for (let j = 0; j < colWidth[i].length; j++) {
      if (result[j]['wch'] < colWidth[i][j]['wch']) {
        result[j]['wch'] = colWidth[i][j]['wch']
      }
    }
  }
  ws['!cols'] = result
}

function json2array (key, jsonData) {
  return jsonData.map(v => key.map(j => { return v[j] }))
}

function getHeaderRow (sheet) {
  const headers = []
  const range = XLSX.utils.decode_range(sheet['!ref'])
  let C
  const R = range.s.r
  for (C = range.s.c; C <= range.e.c; ++C) {
    let cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]
    let hdr = 'UNKNOWN ' + C
    if (cell && cell.t) hdr = XLSX.utils.format_cell(cell)
    headers.push(hdr)
  }
  return headers
}

export const exportTable2Excel = (id, filename) => {
  const table = document.getElementById(id)
  const wb = XLSX.utils.table_to_book(table)
  XLSX.writeFile(wb, getFileName(filename))
}

export const exportJson2Excel = ({ data, key, title, filename, autoWidthFlag }) => {
  const wb = XLSX.utils.book_new()
  data.unshift(title)
  const ws = XLSX.utils.json_to_sheet(data, { header: key, skipHeader: true })
  if (autoWidthFlag) {
    const arr = json2array(key, data)
    autoWidth(ws, arr)
  }
  XLSX.utils.book_append_sheet(wb, ws, filename)
  XLSX.writeFile(wb, getFileName(filename))
}

export const exportArray2Excel = ({ key, data, title, filename, autoWidthFlag }) => {
  const wb = XLSX.utils.book_new()
  const arr = json2array(key, data)
  arr.unshift(title)
  const ws = XLSX.utils.aoa_to_sheet(arr)
  if (autoWidthFlag) {
    autoWidth(ws, arr)
  }
  XLSX.utils.book_append_sheet(wb, ws, filename)
  XLSX.writeFile(wb, getFileName(filename))
}

export const exportObject2Excel = ({ data, fileName }) => {
  const workbook = XLSX.utils.book_new()
  for (let pageKey in data) {
    let page = data[pageKey]
    const worksheet = XLSX.utils.json_to_sheet(page.rows)
    XLSX.utils.book_append_sheet(workbook, worksheet, page.name)
    XLSX.utils.sheet_add_aoa(worksheet, page.headers, { origin: 'A1' })
  }
  XLSX.writeFile(workbook, getFileName(fileName))
}

export const read = (data, type) => {
  const workbook = XLSX.read(data, { type: type })
  const firstSheetName = workbook.SheetNames[0]
  const worksheet = workbook.Sheets[firstSheetName]
  const header = getHeaderRow(worksheet)
  const results = XLSX.utils.sheet_to_json(worksheet, { raw: false })
  return { header, results }
}

export default {
  exportTable2Excel,
  exportArray2Excel,
  exportJson2Excel,
  exportObject2Excel,
  read
}
